import Resource from '@/api/resources/Resource'

class JobConfigurationServices extends Resource {
    async getJobs() {
        const response = await this.axios.get(`/configuration/jobs`)
        return response.data
    }
}

export default new JobConfigurationServices()
